export default {
  methods: {
    companyLabel(company) {
      if (!company) {
        return "-";
      }
      return company.label || company.name || "-";
    },
    warehouseLabelFromOrder(warehouse) {
      if (!warehouse) {
        return "-";
      }
      if (warehouse.label) {
        return warehouse.label;
      }
      if (warehouse.code && warehouse.name) {
        return `${warehouse.code} — ${warehouse.name}`;
      }
      return warehouse.name || warehouse.code || "-";
    },
    formatOrderMoney(value, currency) {
      if (value === null || value === undefined || value === "") {
        return "-";
      }
      const amount = Number(value);
      if (Number.isNaN(amount)) {
        return "-";
      }
      return `${amount.toFixed(2)} ${currency || ""}`.trim();
    },
    lineCount(item) {
      if (item.items_count != null) {
        return item.items_count;
      }
      if (Array.isArray(item.items)) {
        return item.items.length;
      }
      return "-";
    },
  },
};
